module.exports = __webpack_public_path__ + "img/figma.7afd7e4c.svg";